import { reactive } from "vue";

const state = reactive({ target: null });

export default function useDistroNav() {
  const navigate = (target) => { state.target = target; };
  const clear = () => { state.target = null; };
  return { pending: state, navigate, clear };
}
